import { twMerge } from "tailwind-merge";

export const VIEWPORT_STYLES = {
    right: (negtive?: boolean) => (negtive ? "-right-6 md:-right-8" : "right-6 md:right-8"),
    left: (negtive?: boolean) => (negtive ? "-left-6 md:-left-8" : "left-6 md:left-8"),
    padding: (negtive?: boolean) => (negtive ? "-px-6 md:-px-8" : "px-6 md:px-8"),
    margin: (negtive?: boolean) => (negtive ? "-mx-6 md:-mx-8" : "mx-6 md:mx-8"),
    "right1/2": (negtive?: boolean) => (negtive ? "-right-3 md:-right-4" : "right-3 md:right-4"),
    "left1/2": (negtive?: boolean) => (negtive ? "-left-3 md:-left-4" : "left-3 md:left-4"),
    "padding1/2": (negtive?: boolean) => (negtive ? "-px-3 md:-px-4" : "px-3 md:px-4"),
    viewport: () => twMerge("mx-auto my-0 w-full max-w-viewport", VIEWPORT_STYLES.padding()),
};
